import { Component, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Project } from 'src/app/models/project.model';
import { ProjectService } from 'src/app/services/project.service';
import { ProjectCategoryService } from 'src/app/services/project-category.service';

@Component({
  selector: 'app-project-list',
  templateUrl: './project-list.component.html',
  styleUrls: ['./project-list.component.css']
})
export class ProjectListComponent {

  showSpinner: boolean = true;

  projects: Project[] = [];
  projectSubscription$: Subscription;
  categorySubscription$: Subscription;
  categories: any = [];

  displayedColumns: string[] = ['position', 'title', 'content', 'created_at', 'edit', 'delete'];
  /* displayedColumns: string[] = ['position', 'title', 'category', 'content', 'created_at', 'edit', 'delete']; */
  dataSource: MatTableDataSource<Project>;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(private projectService: ProjectService,
              private router: Router, private categoryService: ProjectCategoryService) {}

  ngOnInit(): void {
    
    this.categoryService.getAllCategorys();
    window.scrollTo(0, 0);
    this.categorySubscription$ = this.categoryService.projectCategorySubject$.subscribe(
      (response: any) => {
        this.categories = response;
      },
      (error) => {
        console.log("An Error occured: " + error);
      }
    )


    this.projectService.getAllProjects();
    this.projectSubscription$ = this.projectService.projectSubject$.subscribe(
      (response: Project[]) => {
        this.projects = response;
        this.projects = [...this.projects.map(x => JSON.parse(JSON.stringify(x)))];
        // Sort projects from newest to oldest (most recent first) by start_date
        this.projects = this.projects.sort((a, b) => {
          const dateA = a.start_date ? new Date(a.start_date).getTime() : 0;
          const dateB = b.start_date ? new Date(b.start_date).getTime() : 0;
          return dateB - dateA; // Descending order (most recent start date first)
        }).map(project => {
          let subDes = project.content.replace(/<(.+?)>/g, '');
          if (subDes.length > 40) {
            subDes = subDes.substring(0, 40);
            subDes = subDes.substring(0, subDes.lastIndexOf(' '));
            subDes += '...';
          }
          project.content = subDes;


         /*  let category = this.categories.find((cat: any) => cat.id?.toString() === project.category_id?.toString());

          if(category) {

            project.category_name = category.name;


            console.log('Project', project);
          } */

          return project;
        });
        this.showSpinner = false;
    
        this.dataSource = new MatTableDataSource(this.projects);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      },
      (error) => {
        console.log('An error occured: ' + error);
      }
    );
  }
  
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  deleteProject(project: Project) {
    this.projectService.deleteProject(project.id ?? 0).subscribe(
      (response) => {
        console.log(response);
        this.projectService.emitProjectSubject();
        this.ngOnInit();
      }
    );
  }

  ngOnDestroy(): void {
    this.projectSubscription$.unsubscribe();
  }

}
